import { Routes } from '@angular/router';
import { HomeComponent } from '@feature/home/home.component';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', loadComponent: () => import('@feature/home/home.component').then(m => m.HomeComponent) },
  { path: 'aboutus', loadComponent: () => import('@feature/aboutus/aboutus.component').then(m => m.AboutusComponent)},
  { path: 'contactus', loadComponent: () => import('@feature/contactus/contactus.component').then(m => m.ContactusComponent)},
  { path: 'catering', loadComponent: () => import('@feature/catering/catering.component').then(m => m.CateringComponent)},
  { path: 'services', loadComponent: () => import('@feature/services/services.component').then(m => m.ServicesComponent)},
  { path: 'weeklyspecials', loadComponent: () => import('@feature/weeklyspecials/weeklyspecials.component').then(m => m.WeeklyspecialsComponent) },
  { path: 'fromemail', redirectTo: '/weeklyspecials', pathMatch: 'full' },
  { path: 'shopping', loadComponent: () => import('@feature/shopping/shopping.component').then(m => m.ShoppingComponent) },
  { path: 'employment', loadComponent: () => import('@feature/employment/employment.component').then(m => m.EmploymentComponent) },
  { path: 'emailsignup', loadComponent: () => import('@feature/emailsignup/emailsignup.component').then(m => m.EmailsignupComponent) },

];
